import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Chip } from 'src/components/Chip/Chip';
import ElementIcon, { Icons } from 'src/components/ElementIcon/ElementIcon';
import { PortableHeader } from 'src/components/PortableHeader/PortableHeader';
import * as classes from './CheppersExpert.module.css';

export const CheppersExpert = ({ cheppersExpert }) => {
  const { name, phoneNumber, email, linkedinUsername, linkedinLink, description, image, position, _rawHeader } = cheppersExpert;
  return (
    <Container as="section" className="py-6">
      <PortableHeader content={_rawHeader} className={classes.header} />
      <Row noGutters className={`${classes.container} mx-auto`}>
        <Col className="text-center" lg={2}>
          <GatsbyImage image={image?.image.asset.gatsbyImageData} alt={image.alt} className={classes.image} objectFit="contain" />
        </Col>
        <Col className="pl-4" lg={10}>
          <Row noGutters className="mt-lg-0 mt-3">
            <Col xs={12} lg={3}>
              <Row className={classes.name}>{name}</Row>
              <Row className={classes.position}>
                <ul>
                  <li>{position}</li>
                </ul>
              </Row>
            </Col>
            <Col xs={12} lg={9} className="mt-lg-0 align-self-center mt-2">
              <div className={classes.chipContainer}>
                <Chip backgroundColor="#62D3FF">
                  <a href={linkedinLink} className="text-black">
                    <ElementIcon icon={Icons.linkedin} colorVariant="black" height={16} /> {linkedinUsername}
                  </a>
                </Chip>

                <Chip backgroundColor="#62D3FF">
                  <a href={`mailto:${email}`} className="text-black">
                    <ElementIcon icon={Icons.email} colorVariant="black" height={16} /> {email}
                  </a>
                </Chip>

                <Chip backgroundColor="#ffffff" border="1px solid rgba(0, 0, 0, 0.15)">
                  <a href={`tel:${phoneNumber.replace(/\s/g, '')}`} className="text-black">
                    <ElementIcon icon={Icons.phone} colorVariant="black" height={16} /> {phoneNumber}
                  </a>
                </Chip>
              </div>
            </Col>
          </Row>
          <hr className="my-2" />
          <Row noGutters className={classes.description}>
            {description}
          </Row>
        </Col>
      </Row>
    </Container>
  );
};
